"use client"
import React from 'react'

const GoogleReviews = () => {
    return (
        <div>
            <main className=" bg-white py-16">
                <section className="">
                    <div className="">
                        <div className="flex flex-col items-center gap-4">
                            <div className="w-full h-[750px]">
                                <iframe
                                    src="https://widgets.sociablekit.com/google-reviews/iframe/25469769"  
                                    frameBorder="0"
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}

export default GoogleReviews

